import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithCloseBtn from 'components/root/partials/header/ShortHeaderWithCloseBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesMedicalRecords } from "reduxx/actions/pages/user/medicalRecords";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { useEffect } from 'react';
import { EDIT_MEDICAL_RECORDS_1 } from 'apis';
import apiRequest from 'utils/apiRequest';

const EditMedicalRecord1 = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { hasSpecialDisease, diseaseName } = useSelector(state => state.medicalRecords);

    useEffect(() => {
        dispatch(handleChangeDataPagesMedicalRecords('hasSpecialDisease', profile.medicalRecords.hasSpecialDisease));
        dispatch(handleChangeDataPagesMedicalRecords('diseaseName', profile.medicalRecords.diseaseName));
    }, [EditMedicalRecord1]);


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        if(name === 'hasSpecialDisease')
        	dispatch(handleChangeDataPagesMedicalRecords(name, value === '1'));
        else
        	dispatch(handleChangeDataPagesMedicalRecords(name, value));

    };


    const handleSubmitForm = () => {
    	if(hasSpecialDisease === null)
			dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا مشخص کنید که دارای بیماری خاص میباشید یا خیر', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else if(hasSpecialDisease && (diseaseName === null || diseaseName.trim().length === 0) )
			dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام بیماری را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
		else {
			apiRequest({
                dispatch,
                endpoint: EDIT_MEDICAL_RECORDS_1,
                method: 'post',
                data: { hasSpecialDisease: (hasSpecialDisease ? 1 : 0), diseaseName },
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                	let newProfile = profile;
                	newProfile.medicalRecords.hasSpecialDisease = hasSpecialDisease;
                	newProfile.medicalRecords.diseaseName = diseaseName;
                	dispatch(handleChangeProfileData(newProfile));

                    navigate(`/medical-record2`);
                }
            });
		}
    };		

    return (
        
        <div className={sharedStyles.container}>
        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithCloseBtn />
        		
	            <div className={[formStyles.title, formStyles['mb-24'], formStyles['text-right']].join(' ')}>لطفا پرونده پزشکی خود را تکمیل فرمایید</div>

				<span className={formStyles['text-black']}>آیا بیماری خاصی دارید؟</span>
				<div className={formStyles.radioGroup}>
					<label className={formStyles.radioLabel}><input type="radio" name="hasSpecialDisease" value={0} onChange={handelChangeInputs}  checked={hasSpecialDisease === false} /> خیر</label>
					<label className={formStyles.radioLabel}><input type="radio" name="hasSpecialDisease" value={1} onChange={handelChangeInputs}  checked={hasSpecialDisease === true} /> بله</label>
				</div>
				{ hasSpecialDisease &&
					<>
					<span className={formStyles['text-black']}>لطفا نام بیماری را ذکر کنید</span>
                    <textarea name="diseaseName" value={diseaseName} onChange={handelChangeInputs} className={formStyles.descriptionBox} placeholder="نام بیماری" />
					</>
				}
				<button onClick={handleSubmitForm} className={formStyles.button}>تایید</button>
        	</div>

		</div>

    );
}

export default EditMedicalRecord1;